import { render, staticRenderFns } from "./GoodsManageLayout.vue?vue&type=template&id=2f2b5218&scoped=true"
import script from "./GoodsManageLayout.vue?vue&type=script&lang=js"
export * from "./GoodsManageLayout.vue?vue&type=script&lang=js"
import style0 from "./GoodsManageLayout.vue?vue&type=style&index=0&id=2f2b5218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b5218",
  null
  
)

export default component.exports